import { render, staticRenderFns } from "./AdminAccountEmailDetail.vue?vue&type=template&id=2cc8fb91&"
import script from "./AdminAccountEmailDetail.vue?vue&type=script&lang=js&"
export * from "./AdminAccountEmailDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminAccountEmailDetail.vue?vue&type=style&index=0&id=2cc8fb91&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports